import apiService from "./apiService";

export const dashboardService = {
    getDashboardDetails: (url, params) => apiService.get(url, params),
}